import m from "mithril";
const View = {
    view() {
        return (m("article", null,
            m("div", { class: "alert alert--warning tc" },
                m("i", { class: "fas fa-exclamation-triangle" }),
                m("div", { class: "b" },
                    m("p", null,
                        "Zurzeit finden Wartungsarbeiten statt.",
                        m("br", null),
                        "Bitte probieren Sie es sp\u00E4ter noch einmal."),
                    m("p", { class: "pb0" }, "Vielen Dank f\u00FCr Ihr Verst\u00E4ndis!")))));
    },
};
export default View;
